import { render, staticRenderFns } from "./back-stock-new-pick-h5.vue?vue&type=template&id=5b65a129&scoped=true"
import script from "./back-stock-new-pick-h5.vue?vue&type=script&lang=js"
export * from "./back-stock-new-pick-h5.vue?vue&type=script&lang=js"
import style0 from "./back-stock-new-pick-h5.vue?vue&type=style&index=0&id=5b65a129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65a129",
  null
  
)

export default component.exports